import { GraphQLObjectType, GraphQLString, GraphQLNonNull, GraphQLID } from 'graphql';
import { toGlobalId } from 'graphql-relay';

import UserType from './user.gql';

const questionFeedbackType = new GraphQLObjectType({
  name: 'QuestionFeedback',
  fields: () => ({
    id: {
      type: new GraphQLNonNull(GraphQLID),
      resolve: item => toGlobalId('QuestionFeedback', item._id)
    },
    pid: {
      type: GraphQLString,
      resolve: item => item._id
    },
    feedback: {
      type: GraphQLString
    },
    feedbackGivenBy: {
      type: UserType
    }
  })
});

window[questionFeedbackType.name + 'GQLType'] = questionFeedbackType;

export default questionFeedbackType;
